import useSWR from "swr";
import Layout from "../../../components/custom/Layout";
import MonthYearPicker from "../../../components/MonthYearPicker";
import useMonthYear from "../../../components/MonthYearPicker/useMonthYear";
import { customFetcher } from "../../../utils";
import VirtualTable from "../../../components/custom/VirtualTable";
import { renderToString } from "react-dom/server";
import Waiver from "./Waiver";
import useUser from "../../../customHooks/useUser";
import useAppData from "../../../customHooks/useAppData";
import useStationInfo from "../../../components/reporting/breakdownProgress/useStationInfo";
import { useState } from "react";

export interface DisclosureWaiver {
    id: number;
    email: string;
    name: string;
    mawb: string;
    amount: number;
    authorityToAgree: boolean;
    specialRateExceptionAgreement: boolean;
    legalEnforceabilityAgreement: boolean;
    paymentNonDisputeAgreement: boolean;
    created: Date | string;
}

export default function DisclosureWaiverAcknowledgment() {

    const { user } = useUser();
    const stationInfo = useStationInfo();
    const { month, setMonth, year, setYear } = useMonthYear();
    const swrKey = (month && year) ?
        `/disclosure-waiver-data?month=${month}&year=${year}` : null;

    const {
        data
    } = useSWR(swrKey, customFetcher<DisclosureWaiver>, {
        fallbackData: []
    });

    const generateWaiver = (waiver: DisclosureWaiver) => {
        const sheet = renderToString(
            <Waiver
                waiver={waiver}
                user={user}
                stationInfo={stationInfo}
            />
        );

        const myWindow = window.open("", "MsgWindow", "width=1920,height=1080");
        //@ts-ignore
        myWindow.document.body.innerHTML = null;
        //@ts-ignore
        myWindow.document.write(sheet);
    }

    return (
        <Layout>
            <h1>Disclosure Waiver Acknowledgment</h1>
            <MonthYearPicker
                setMonth={setMonth}
                setYear={setYear}
            />
            <VirtualTable<DisclosureWaiver>
                data={data}
                mapping={[{
                    name: 'Email',
                    value: 'email'
                }, {
                    name: 'MAWB/HAWB',
                    value: 'mawb'
                }, {
                    name: 'Amount',
                    value: 'amount'
                }, {
                    name: 'Created',
                    value: 'created',
                    datetime: true
                }]}
                handleClick={item => generateWaiver(item)}
            />
        </Layout>
    );
}